class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
if (document.querySelector('.gift-select-btn')){
  document.querySelector('.gift-select-btn').addEventListener('click',function(evt){
    evt.preventDefault();
    document.querySelector('.gift-btns').classList.add('active-addcart');
  });
}
if (document.querySelector('.gift-add-btn a')) {
  document.querySelectorAll('.gift-add-btn a').forEach(function (gift_add) {
    gift_add.addEventListener('click', function (event) {
      event.preventDefault();

      let data = {
        id: gift_add.getAttribute('data-id'),
        quantity: 1
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
        .then(res => res.json())
        .then((response) => {

          // --- ERROR FROM SHOPIFY ---
          if (response.status) {
            console.error(response.description || "Error adding gift product");
            return;
          }

          // --- SUCCESS ---
          const title = gift_add.getAttribute('data-pro-title') || '';
          const imgSrc = gift_add.getAttribute('data-img-src') || '';

          // POPUP ELEMENTS
          const cartPopup = document.getElementById('cart-popup');
          const popupTitle = document.getElementById('cart-popup-title');
          const popupImage = document.getElementById('cart-popup-image');
          let popupTimer;

          // Set Popup Content
          if (cartPopup && popupTitle && popupImage) {
            popupTitle.textContent = title;
            popupImage.src = imgSrc;

            cartPopup.classList.remove('hidden');
            cartPopup.classList.add('visible');

            clearTimeout(popupTimer);
            popupTimer = setTimeout(() => {
              cartPopup.classList.remove('visible');
              setTimeout(() => cartPopup.classList.add('hidden'), 300);
            }, 3000);
          }

          // IF ON CART PAGE → REFRESH
          if (document.location.href.indexOf('/cart') > -1) {
            window.location.href = '/cart';
          } else {
            if (typeof load_cart === 'function') {
              load_cart();
              setTimeout(() => {
                // document.querySelector('body').classList.add('open-drawer');
              }, 500);
            }
          }

        })
        .catch((error) => console.error("Error:", error));
    });
  });
}

// if (document.querySelector('.product-addcart')){
//   document.querySelector('.product-addcart').addEventListener('click',function(evt){
//     evt.preventDefault();
//     const config = fetchConfig('javascript');
//     config.headers['X-Requested-With'] = 'XMLHttpRequest';
//     delete config.headers['Content-Type'];
//     var cartform = document.querySelector('.product-addcart').closest('form');
//     const formData = new FormData(cartform);  
//     config.body = formData;

//     const title = this.getAttribute('data-pro-title') || '';
//     const imgSrc = this.getAttribute('data-img-src') || '';

//     const cartPopup = document.getElementById('cart-popup');
//     const popupTitle = document.getElementById('cart-popup-title');
//     const popupImage = document.getElementById('cart-popup-image');
//     const popupClose = document.querySelector('.cart-popup-close');

//     let popupTimer;


//     fetch(`${routes.cart_add_url}`, config)
//     .then((response) => response.json())
//     .then((response) => {
//       if (response.status) {
//         document.querySelector('.product-form-error').innerHTML = response.description;
//         setTimeout(function(e){
//           document.querySelector('.product-form-error').innerHTML  = '';
//         },2000);
//         return;
//       }else{
//         if(typeof load_cart == 'function'){
//           load_cart();
//           popupTitle.textContent = title;
//             popupImage.src = imgSrc;

//             cartPopup.classList.remove('hidden');
//             cartPopup.classList.add('visible');

//             clearTimeout(popupTimer);
//             popupTimer = setTimeout(() => {
//               cartPopup.classList.remove('visible');
//               setTimeout(() => cartPopup.classList.add('hidden'), 300);
//             }, 3000);
         

//         }else{
//           window.location.href = "/cart";
//         }
//       }
//     })
//     .catch((e) => {
//       console.error(e);
//     })
//     .finally(() => {

//     });
//   });
// }


// function fetchConfig(type = 'json') {
//   return {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
//   };
// }

if (document.querySelector('.product-addcart')) {
  // document.querySelector('.product-addcart').addEventListener('click', function (evt) {
  //   evt.preventDefault();

  //   const title = this.getAttribute('data-pro-title') || '';
  //   const imgSrc = this.getAttribute('data-img-src') || '';
  //   const productType = this.getAttribute('data-type')?.toLowerCase() || '';
  //   const freeGiftVariant = window.freeGiftVariantID || null;

  //   const cartform = this.closest('form');
  //   const config = fetchConfig('javascript');
  //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
  //   delete config.headers['Content-Type'];

  //   const formData = new FormData(cartform);
  //   config.body = formData;

  //   fetch(`${routes.cart_add_url}`, config)
  //     .then((response) => response.json())
  //     .then(async (response) => {
  //       // ERROR
  //       if (response.status) {
  //         document.querySelector('.product-form-error').innerHTML = response.description;
  //         setTimeout(() => {
  //           document.querySelector('.product-form-error').innerHTML = '';
  //         }, 2000);
  //         return;
  //       }

  //       // ------------------------------------------
  //       // 1️⃣ CHECK IF FREE GIFT IS NEEDED
  //       // ------------------------------------------
  //       const isPerfume =
  //         productType.includes("perfume") ||
  //         productType.includes("parfum") ||
  //         productType.includes("eau de");

  //       let giftAlreadyPresent = false;

  //       if (freeGiftVariant && isPerfume) {
  //         // 2️⃣ Check cart first
  //         const cart = await fetch('/cart.js').then(res => res.json());

  //         cart.items.forEach(item => {
  //           if (item.variant_id == freeGiftVariant) giftAlreadyPresent = true;
  //         });

  //         // 3️⃣ Add gift ONLY IF NOT already in cart
  //         if (!giftAlreadyPresent) {
  //           await fetch('/cart/add.js', {
  //             method: 'POST',
  //             headers: { 'Content-Type': 'application/json' },
  //             body: JSON.stringify({
  //               items: [{ id: freeGiftVariant, quantity: 1 }],
  //             }),
  //           });
  //         }
  //       }

  //       // ------------------------------------------
  //       // 4️⃣ NOW UPDATE CART OR REDIRECT
  //       // ------------------------------------------
  //       if (typeof load_cart == 'function') {
  //         load_cart();

  //         // Popup
  //         const cartPopup = document.getElementById('cart-popup');
  //         const popupTitle = document.getElementById('cart-popup-title');
  //         const popupImage = document.getElementById('cart-popup-image');
  //         const popupClose = document.querySelector('.cart-popup-close');

  //         popupTitle.textContent = title;
  //         popupImage.src = imgSrc;

  //         cartPopup.classList.remove('hidden');
  //         cartPopup.classList.add('visible');

  //         let popupTimer = setTimeout(() => {
  //           cartPopup.classList.remove('visible');
  //           setTimeout(() => cartPopup.classList.add('hidden'), 300);
  //         }, 3000);

  //         if (popupClose && !popupClose.hasListener) {
  //           popupClose.addEventListener('click', function () {
  //             clearTimeout(popupTimer);
  //             cartPopup.classList.remove('visible');
  //             setTimeout(() => cartPopup.classList.add('hidden'), 300);
  //           });
  //           popupClose.hasListener = true;
  //         }
  //       } else {
  //         window.location.href = "/cart";
  //       }
  //     })
  //     .catch((e) => console.error(e));
  // });
  document.querySelectorAll('.product-addcart').forEach(button => {
  button.addEventListener('click', function (evt) {
    evt.preventDefault();

    const title = this.getAttribute('data-pro-title') || '';
    const imgSrc = this.getAttribute('data-img-src') || '';
    const productType = this.getAttribute('data-type')?.toLowerCase() || '';
    const freeGiftVariant = window.freeGiftVariantID || null;

    const cartform = this.closest('form');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(cartform);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then(async (response) => {
        // ERROR
        if (response.status) {
          document.querySelector('.product-form-error').innerHTML = response.description;
          setTimeout(() => {
            document.querySelector('.product-form-error').innerHTML = '';
          }, 2000);
          return;
        }

        // ------------------------------------------
        // 1️⃣ CHECK IF FREE GIFT IS NEEDED
        // ------------------------------------------
        const isPerfume =
          productType.includes("perfume") ||
          productType.includes("parfum") ||
          productType.includes("eau de");

        let giftAlreadyPresent = false;

        if (freeGiftVariant && isPerfume) {
          // 2️⃣ Check cart first
          const cart = await fetch('/cart.js').then(res => res.json());

          cart.items.forEach(item => {
            if (item.variant_id == freeGiftVariant) giftAlreadyPresent = true;
          });

          // 3️⃣ Add gift ONLY IF NOT already in cart
          if (!giftAlreadyPresent) {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: freeGiftVariant, quantity: 1 }],
              }),
            });
          }
        }

        // ------------------------------------------
        // 4️⃣ NOW UPDATE CART OR REDIRECT
        // ------------------------------------------
        if (typeof load_cart == 'function') {
          load_cart();

          // Popup
          const cartPopup = document.getElementById('cart-popup');
          const popupTitle = document.getElementById('cart-popup-title');
          const popupImage = document.getElementById('cart-popup-image');
          const popupClose = document.querySelector('.cart-popup-close');

          popupTitle.textContent = title;
          popupImage.src = imgSrc;

          cartPopup.classList.remove('hidden');
          cartPopup.classList.add('visible');

          let popupTimer = setTimeout(() => {
            cartPopup.classList.remove('visible');
            setTimeout(() => cartPopup.classList.add('hidden'), 300);
          }, 3000);

          if (popupClose && !popupClose.hasListener) {
            popupClose.addEventListener('click', function () {
              clearTimeout(popupTimer);
              cartPopup.classList.remove('visible');
              setTimeout(() => cartPopup.classList.add('hidden'), 300);
            });
            popupClose.hasListener = true;
          }
        } else {
          window.location.href = "/cart";
        }
      })
      .catch((e) => console.error(e));
  });
});

}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto'
    });
    var swiper2 = new Swiper(".media-nav", {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  }
}
product_slider();
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const toggleSets = document.querySelectorAll(".get-pro-set");

  toggleSets.forEach(toggleSet => {
    const listWrap = toggleSet.querySelector(".get-pro-list-wrap");
    const inner = toggleSet.querySelector(".get-pro-list-inner");
    const trigger = toggleSet.querySelector("a");

    if (!listWrap || !inner || !trigger) return;

    trigger.addEventListener("click", e => {
      e.preventDefault();
      const isActive = toggleSet.classList.toggle("active");
      listWrap.style.maxHeight = isActive ? inner.scrollHeight + "px" : 0;
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".variant-tab");
  const wrappers = document.querySelectorAll(".variants-multi-wrapper");
  const variantImages = document.querySelectorAll(".variant-image");
  const extraVariants = document.querySelectorAll(".extra-variant");
  const addToCartBtn = document.querySelector(".multi-pro-add-tocart");

  if (!tabs.length) return;

  function updateATCAttributes(el) {
  if (!el || !addToCartBtn) return;

  const varId = el.dataset.varId;
  const proTitle = el.dataset.proTitle;
  const imgSrc = el.dataset.imgSrc; 

  addToCartBtn.dataset.varId = varId;
  addToCartBtn.dataset.proTitle = proTitle;
  addToCartBtn.dataset.imgSrc = imgSrc;

  // DEBUG → See actual value
  console.log("Updated ATC:", { varId, proTitle, imgSrc });
}


  /* ---------------- EV LIST CLICK HANDLER ---------------- */
  document.querySelectorAll(".ev-list").forEach(list => {
    list.addEventListener("click", function () {

      // Remove active from siblings
      const parent = this.closest(".ev-wrap");
      if (parent) {
        parent.querySelectorAll(".ev-list").forEach(l => l.classList.remove("active"));
      }

      let price = this.getAttribute("data-price");
      if (price) {
        this.closest('.snippet-addto-cart')
          .querySelectorAll('.pdp-btn-price')
          .forEach(btn => btn.textContent = price);
      }

      // Add active to clicked
      this.classList.add("active");

      // Update ATC attributes
      updateATCAttributes(this);
    });
  });

  /* ---------------- TAB CLICK HANDLER ---------------- */
  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const group = this.getAttribute("data-group");

      /* ---- PRICE UPDATE ---- */
      let price = this.getAttribute("data-price");
      if (price) {
        this.closest('.snippet-addto-cart')
          .querySelectorAll('.pdp-btn-price')
          .forEach(btn => btn.textContent = price);
      }

      /* ---- TAB ACTIVE ---- */
      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      /* ---- WRAPPER SWITCH ---- */
      wrappers.forEach(w => w.classList.remove("active"));
      const activeWrapper = document.querySelector(`.variants-multi-wrapper[data-id="${group}"]`);
      if (activeWrapper) activeWrapper.classList.add("active");

      /* ---- IMAGE SWITCH ---- */
      variantImages.forEach(img => img.classList.remove("active-image"));
      const activeImage = document.querySelector(`.variant-image[data-img-id="${group}"]`);
      if (activeImage) activeImage.classList.add("active-image");

      /* ---- EXTRA VARIANT SWITCH ---- */
      extraVariants.forEach(ex => ex.classList.remove("active-extra"));
      const matchExtra = document.querySelector(`.extra-variant[data-extra="${group}"]`);
      if (matchExtra) matchExtra.classList.add("active-extra");

      /* ---- SET FIRST EV-LIST OF MATCHED EXTRA TO ATC ---- */
      if (matchExtra) {
        const firstList = matchExtra.querySelector(".ev-list");
        if (firstList) updateATCAttributes(firstList);

        // Fix active classes
        matchExtra.querySelectorAll(".ev-list").forEach(l => l.classList.remove("active"));
        if (firstList) firstList.classList.add("active");
      }
    });
  });
});

if (document.querySelector('.multi-pro-add-tocart')) {
  document.querySelector('.multi-pro-add-tocart').addEventListener('click', function (evt) {
    evt.preventDefault();

    const selectedVarId = this.dataset.varId;
    const title = this.dataset.proTitle || '';
    const imgSrc = this.dataset.imgSrc || '';

    const cartPopup = document.getElementById('cart-popup');
    const popupTitle = document.getElementById('cart-popup-title');
    const popupImage = document.getElementById('cart-popup-image');
    const popupClose = document.querySelector('.cart-popup-close');

    let popupTimer;

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData();
    formData.append('id', selectedVarId);
    formData.append('quantity', 1); 
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {

        if (response.status) {
          document.querySelector('.product-form-error').innerHTML = response.description;
          setTimeout(() => {
            document.querySelector('.product-form-error').innerHTML = '';
          }, 2000);
          return;
        }

        if (typeof load_cart == 'function') {
          load_cart();

          popupTitle.textContent = title;
          popupImage.src = imgSrc;

          cartPopup.classList.remove('hidden');
          cartPopup.classList.add('visible');

          clearTimeout(popupTimer);
          popupTimer = setTimeout(() => {
            cartPopup.classList.remove('visible');
            setTimeout(() => cartPopup.classList.add('hidden'), 300);
          }, 3000);
        } else {
          window.location.href = "/cart";
        }
      })
      .catch((e) => console.error(e));
  });
}



// ============================ discover set 

document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector(".discover-add-to-cart")){
     const wrappers = document.querySelectorAll(".discovery-set-wrapper");
      const addToCartBtn = document.querySelector(".discover-add-to-cart");

      // --- Toggle dropdown visibility ---
      document.querySelectorAll(".discovery-set-title").forEach(title => {
        title.addEventListener("click", function () {
          const dropWrap = this.nextElementSibling;
          const isOpen = dropWrap.classList.contains("open");

          // Close all dropdowns
          document.querySelectorAll(".discovery-set-drop-wrap").forEach(w => {
            w.classList.remove("open");
            lenis.start();
            if (window.innerWidth > 991) {
              w.style.maxHeight = "0px";
              w.style.opacity = "0";
              w.style.visibility = "hidden";
            }
            w.previousElementSibling.classList.remove("active-title"); // remove active from title
          });


          dropWrap.addEventListener('wheel', (e) => {
            // allow normal scroll inside sidebar
            e.stopPropagation();
          }, { passive: false });

          dropWrap.addEventListener('touchstart', (e) => {
            e.stopPropagation();
          }, { passive: false });

          dropWrap.addEventListener('touchmove', (e) => {
            e.stopPropagation();
          }, { passive: false });

          // Toggle the clicked one
          if (!isOpen) {
            dropWrap.classList.add("open");
            lenis.stop();
            if (window.innerWidth > 991) {
              dropWrap.style.maxHeight = dropWrap.scrollHeight + "px";
              dropWrap.style.opacity = "1";
              dropWrap.style.visibility = "visible";
            }else{
              dropWrap.style.visibility = "visible";
              dropWrap.style.opacity = "1";
              dropWrap.style.maxHeight = "100vh";
            }
            this.classList.add("active-title");


          }
        });
      });

      // Close button click
      document.querySelectorAll(".close-popup").forEach(closeBtn => {
        closeBtn.addEventListener("click", function (e) {
          e.preventDefault();
          lenis.start();
          const dropWrap = this.closest(".discovery-set-drop-wrap");
          dropWrap.classList.remove("open");
          if (window.innerWidth > 991) {
            dropWrap.style.maxHeight = "0px";
            dropWrap.style.opacity = "0";
            dropWrap.style.visibility = "hidden";
          }
          const title = dropWrap.previousElementSibling;
          title.classList.remove("active-title");
        });
      });


 



  // --- Handle scent selection ---
  wrappers.forEach(wrapper => {
    wrapper.querySelectorAll("li.discover-set-pro").forEach(li => {
      li.addEventListener("click", function () {
        lenis.start();
        const selectedId = this.dataset.id;
        const titleEl = wrapper.querySelector(".discovery-set-title");

        // Reset others
        wrapper.querySelectorAll("li").forEach(l => l.classList.remove("active"));
        this.classList.add("active");

        // Update title text
        // titleEl.querySelector("span")?.remove();
        // titleEl.querySelector(".dis-new-title").innerHTML = this.textContent;
        // titleEl.classList.add("active-pro");
        const titleText = titleEl.querySelector(".dis-new-title");
        if (titleText) titleText.textContent = this.textContent;
        titleEl.classList.add("active-pro");

        titleEl.dataset.variantId = selectedId;

        // Close dropdown
        const dropWrap = wrapper.querySelector(".discovery-set-drop-wrap");
        dropWrap.classList.remove("open");
        dropWrap.style.maxHeight = "0px";
        dropWrap.style.opacity = "0";
        dropWrap.style.visibility = "hidden";

        // Enable Add to Cart if all selected
        const allSelected = [...wrappers].every(w =>
          w.querySelector(".discovery-set-title.active-pro")
        );
        addToCartBtn.disabled = !allSelected;
      });
    });
  });

  // --- Add to cart ---
  addToCartBtn.addEventListener("click", function (e) {
    e.preventDefault();

    const selectedVariants = [...wrappers]
      .map(w => w.querySelector(".discovery-set-title").dataset.variantId)
      .filter(id => id);

    if (selectedVariants.length === 0) return;

    console.log("selectedVariants",selectedVariants);
      (async () => {
      for (const id of selectedVariants) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, quantity: 1 }),
        });
      }

      const res = await fetch("/cart.js");
      const data = await res.json();

      load_cart();
      document.querySelector(".cart-count").innerHTML = data.item_count;

      // --- CART POPUP ---
      const cartPopup = document.getElementById("cart-popup");
      const popupTitle = document.getElementById("cart-popup-title");
      const popupImage = document.getElementById("cart-popup-image");
      const popupClose = document.querySelector(".cart-popup-close");
      const discover_title = document.querySelector(".main-discover-set-wrapper");
      

      let popupTimer;

      if (cartPopup && popupTitle && popupImage) {
        popupTitle.textContent = discover_title.getAttribute('data-title');
        popupImage.src = discover_title.getAttribute('data-img-src');

        cartPopup.classList.remove("hidden");
        cartPopup.classList.add("visible");

        clearTimeout(popupTimer);
        popupTimer = setTimeout(() => {
          cartPopup.classList.remove("visible");
          setTimeout(() => cartPopup.classList.add("hidden"), 300);
        }, 3000);
      }

      if (popupClose && !popupClose.hasListener) {
        popupClose.addEventListener("click", function () {
          clearTimeout(popupTimer);
          cartPopup.classList.remove("visible");
          setTimeout(() => cartPopup.classList.add("hidden"), 300);
        });
        popupClose.hasListener = true;
      }
    })();

  });
  }
});



if (screen.width < 992) {
  const mobileTrigger = document.querySelector(".mobile-multi-size");
  const closeBtn = document.querySelector(".close-popup");

  if (mobileTrigger) {
    mobileTrigger.addEventListener("click", function(e) {
      e.preventDefault();
      document.body.classList.add("open-mobile-var");
      lenis.stop();
    });
  }

  if(closeBtn) document.querySelectorAll('.close-popup').forEach(function(closePopup){
    closePopup.addEventListener("click", function(e){
      e.preventDefault();
      document.body.classList.remove("open-mobile-var");
      lenis.start();
    });
  });
}


 document.querySelectorAll('.variant-grid').forEach(function (sizeList) {
  sizeList.addEventListener('click', function (e) {
    e.preventDefault();
    let variant_id = sizeList.dataset.id;
    let error_grid_outer = sizeList.closest('.variants-multi-wrapper');
    let error_grid = error_grid_outer.querySelector('.grid-error');

    let formData = {
      items: [
        {
          id: variant_id,
          quantity: 1,
        },
      ],
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        // ----- Handle Error -----
        if (data.status == 422) {
          error_grid.innerHTML = data.description;
          setTimeout(function () {
            error_grid.innerHTML = '';
          }, 2000);
          return;
        }

        // ----- If Success -----
        if (document.location.href.indexOf('/cart') > -1) {
          window.location.href = '/cart';
        } else {
          if (typeof load_cart == 'function') {
            document.body.classList.remove('open-mobile-var');
            setTimeout(() => {
              load_cart();
            }, 1000);
            // setTimeout(function () {
            //   document.querySelector('body').classList.add('open-drawer');
            // }, 500);
          } else {
            window.location.href = '/cart';
          }
        }

        // ----- Update Cart Count -----
        fetch('/cart.js')
          .then((resp) => resp.json())
          .then(function (data) {
            var cart_count = data.item_count;
            document.querySelector('.cart-count').innerHTML = cart_count;
          })
          .catch(function (error) {
            console.log(error);
          });

        // ----- CART NOTIFICATION -----
        const title = sizeList.getAttribute('data-pro-title') || '';
        const imgSrc = sizeList.getAttribute('data-img-src') || '';

        const cartPopup = document.getElementById('cart-popup');
        const popupTitle = document.getElementById('cart-popup-title');
        const popupImage = document.getElementById('cart-popup-image');
        const popupClose = document.querySelector('.cart-popup-close');

        let popupTimer;

        if (cartPopup && popupTitle && popupImage) {
          popupTitle.textContent = title;
          popupImage.src = imgSrc;

          // Show popup
          cartPopup.classList.remove('hidden');
          cartPopup.classList.add('visible');

          clearTimeout(popupTimer);

          // Hide after 3s
          popupTimer = setTimeout(() => {
            cartPopup.classList.remove('visible');
            setTimeout(() => cartPopup.classList.add('hidden'), 300);
          }, 3000);
        }

        // Manual close (attach once)
        if (popupClose && !popupClose.hasListener) {
          popupClose.addEventListener('click', function () {
            clearTimeout(popupTimer);
            cartPopup.classList.remove('visible');
            setTimeout(() => cartPopup.classList.add('hidden'), 300);
          });
          popupClose.hasListener = true;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  });
});

function updateFixedButtons() {
  const productWrap = document.querySelector('.product-wrap');
  const headerLogo = document.querySelector('.header-main-logo');
  const mobileATC = document.querySelector('.mobile-fixed-add-to-cart');

  if (!productWrap || !headerLogo) return;

  function isMobile() {
    return window.innerWidth <= 991;
  }

  function elementInViewport(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function checkSectionPosition() {
    if (!isMobile()) {
      document.body.classList.remove('is-fixed');
      return;
    }

    // REMOVE is-fixed if mobile add-to-cart section is visible
    if (elementInViewport(mobileATC)) {
      document.body.classList.remove('is-fixed');
      return;
    }

    const isActive = headerLogo.classList.contains('active-logo');
    const rect = productWrap.getBoundingClientRect();
    const sectionInView = rect.top < window.innerHeight && rect.bottom > 0;
    const sectionEndReached = rect.bottom <= window.innerHeight;
    const scrolledIntoSection = Math.max(0, window.innerHeight - rect.top);

    if (
      isActive &&
      sectionInView &&
      !sectionEndReached &&
      scrolledIntoSection > 300
    ) {
      document.body.classList.add('is-fixed');
    } else {
      document.body.classList.remove('is-fixed');
    }
  }

  window.addEventListener('scroll', checkSectionPosition, { passive: true });
  window.addEventListener('resize', checkSectionPosition);
  checkSectionPosition();
}

document.addEventListener('DOMContentLoaded', updateFixedButtons);

// function updateFixedButtons() {
//   const productWrap = document.querySelector('.product-wrap');
//   const headerLogo = document.querySelector('.header-main-logo');

//   if (!productWrap || !headerLogo) return;

//   function isMobile() {
//     return window.innerWidth <= 991;
//   }

//   function checkSectionPosition() {
//     if (!isMobile()) {
//       document.body.classList.remove('is-fixed');
//       return;
//     }

//     const isActive = headerLogo.classList.contains('active-logo');

//     const rect = productWrap.getBoundingClientRect();
//     const sectionInView = rect.top < window.innerHeight && rect.bottom > 0;
//     const sectionEndReached = rect.bottom <= window.innerHeight;

//     const scrolledIntoSection = Math.max(0, window.innerHeight - rect.top);

//     // NEW LOGIC: Only add is-fixed if header logo is active
//     if (
//       isActive &&
//       sectionInView &&
//       !sectionEndReached &&
//       scrolledIntoSection > 300
//     ) {
//       document.body.classList.add('is-fixed');
//     } else {
//       document.body.classList.remove('is-fixed');
//     }
//   }

//   window.addEventListener('scroll', checkSectionPosition, { passive: true });
//   window.addEventListener('resize', checkSectionPosition);
//   checkSectionPosition();
// }

// document.addEventListener('DOMContentLoaded', updateFixedButtons);


// function updateFixedButtons() {
//   const productWrap = document.querySelector('.product-wrap');
//   if (!productWrap) return;

//   function isMobile() {
//     return window.innerWidth <= 991;
//   }

//   function checkSectionPosition() {
//     if (!isMobile()) {
//       document.body.classList.remove('is-fixed');
//       return;
//     }

//     const rect = productWrap.getBoundingClientRect();
//     const sectionInView = rect.top < window.innerHeight && rect.bottom > 0;
//     const sectionEndReached = rect.bottom <= window.innerHeight;

//     // Calculate how far the user has scrolled into the section
//     const scrolledIntoSection = Math.max(0, window.innerHeight - rect.top);

//     if (sectionInView && !sectionEndReached && scrolledIntoSection > 150) {
//       document.body.classList.add('is-fixed');
//     } else {
//       document.body.classList.remove('is-fixed');
//     }
//   }

//   window.addEventListener('scroll', checkSectionPosition, { passive: true });
//   window.addEventListener('resize', checkSectionPosition);
//   checkSectionPosition();
// }

// =============== refill possition

// document.addEventListener("DOMContentLoaded", function () {
//   if (window.innerWidth > 991) {
//     const tabs = document.querySelector(".variant-type-tabs");
//     const productSection = document.querySelector(".product-wrap");
//     if (!tabs || !productSection) return;

//     const maxPadding = 56; // Max padding limit in px

//     // Get section top position
//     const sectionTop = productSection.offsetTop;
//     const sectionHeight = productSection.offsetHeight;

//     function updatePadding() {
//       const scrollY = window.scrollY;
//       const sectionScroll = scrollY - sectionTop;

//       if (scrollY < sectionTop) {
//         // Before section start → no padding
//         tabs.style.paddingTop = "0px";
//         return;
//       }

//       if (scrollY > sectionTop + sectionHeight) {
//         // After section ends → max padding
//         tabs.style.paddingTop = `${maxPadding}px`;
//         return;
//       }

//       // While scrolling inside section — match scroll distance up to maxPadding
//       const newPadding = Math.min(sectionScroll, maxPadding);
//       tabs.style.paddingTop = `${newPadding}px`;
//     }

//     window.addEventListener("scroll", updatePadding);
//     updatePadding();
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const tabs = document.querySelector(".variant-type-tabs");
//   const productSection = document.querySelector(".product-wrap");
//   if (!tabs || !productSection) return;

//   const maxPadding = 116;
//   const sectionTop = productSection.offsetTop;
//   const sectionHeight = productSection.offsetHeight;

//   function handleDesktopScroll() {
//     const scrollY = window.scrollY;
//     const sectionScroll = scrollY - sectionTop;

//     if (scrollY < sectionTop) {
//       tabs.style.paddingTop = "0px";
//       return;
//     }

//     if (scrollY > sectionTop + sectionHeight) {
//       tabs.style.paddingTop = `${maxPadding}px`;
//       return;
//     }

//     const newPadding = Math.min(sectionScroll, maxPadding);
//     tabs.style.paddingTop = `${newPadding}px`;
//   }

//   function handleMobileScroll() {
//     const scrollY = window.scrollY;
//     const sectionBottom = sectionTop + sectionHeight;
    

//     // When the top of product-wrap is above current scroll position
//     if (scrollY + window.innerHeight < sectionBottom) {
//       // fixed to bottom (before reaching section)
//       tabs.style.position = "fixed";
//       tabs.style.bottom = "42px";
//       tabs.style.top = "auto";
//       tabs.style.width = "100%";
//       tabs.classList.remove("not-fixed");
//     } else {
//       // reached section → unfix and stay in normal flow
//       tabs.style.position = "relative";
//       tabs.style.bottom = "0px";
//       tabs.classList.add("not-fixed");
//       tabs.style.top = "auto";
//     }
//   }

//   function updateScroll() {
//     if (window.innerWidth <= 992) {
//       handleMobileScroll();
//     } else {
//       handleDesktopScroll();
//     }
//   }

//   window.addEventListener("scroll", updateScroll);
//   window.addEventListener("resize", updateScroll);
//   updateScroll();
// });

// ================================================================================================================================================



// let stickyTogglePoint = null;

// function checkStickyBar() {
//   if (window.innerWidth > 991) return;

//   const mediaWrap = document.querySelector(".inr-media-wrap");
//   const inner = mediaWrap ? mediaWrap.querySelector(".inner-media") : null;
//   if (!mediaWrap || !inner) return;

//   const wrapTop = mediaWrap.getBoundingClientRect().top;
//   const innerTop = inner.getBoundingClientRect().top;

//   // When both meet, store that point once
//   if (stickyTogglePoint === null && Math.abs(wrapTop - innerTop) <= 2) {
//     stickyTogglePoint = wrapTop;
//   }

//   if (stickyTogglePoint === null) return;

//   // Scroll DOWN → remove class
//   if (wrapTop <= stickyTogglePoint) {
//     document.body.classList.remove("add-img-fixed");
//   }

//   // Scroll UP → add class
//   if (wrapTop > stickyTogglePoint) {
//     document.body.classList.add("add-img-fixed");
//   }
// }

// window.addEventListener("scroll", checkStickyBar);
// window.addEventListener("load", checkStickyBar);

// let resizeTimeout;
// window.addEventListener("resize", () => {
//   clearTimeout(resizeTimeout);
//   resizeTimeout = setTimeout(() => {
//     stickyTogglePoint = null; // recalc on resize
//     checkStickyBar();
//   }, 150);
// });

// // ---- FIX LENIS JUMP ----
// const body = document.body;

// const lockLenis = () => {
//   if (!body.classList.contains("lenis-smooth")) {
//     body.classList.add("lenis-smooth"); // restore immediately
//   }
// };

// // Lenis sometimes removes class on scroll/frame update
// lenis.on("scroll", lockLenis);

// // Also watch DOM changes to avoid accidental removal
// const observer = new MutationObserver(lockLenis);
// observer.observe(body, { attributes: true, attributeFilter: ["class"] });

// ===========================================================================================================================================

// function checkStickyBar() {
//   if (window.innerWidth <= 991) {
//     let mediaWrap = document.querySelector(".inr-media-wrap");
//     // let inner = mediaWrap ? mediaWrap.querySelector('.inner-media') : null;
//     // if (!mediaWrap || !inner) return;
//     // mediaWrap.style.minHeight = inner.offsetHeight + 'px';
//     if(mediaWrap && ((mediaWrap.getBoundingClientRect().height * 2) - 5) + mediaWrap.getBoundingClientRect().top - window.innerHeight < 0){
//       document.querySelector("body").classList.remove("add-img-fixed");
//     }else{
//       document.querySelector("body").classList.add("add-img-fixed");
//     }
//   }
// }
// window.addEventListener("scroll", checkStickyBar);
// window.addEventListener("load", checkStickyBar);
// let resizeTimeout;
// window.addEventListener("resize", function() {
//   clearTimeout(resizeTimeout);
//   resizeTimeout = setTimeout(checkStickyBar, 150);
// });
function checkStickyBar() {
  if (window.innerWidth <= 991) {

    let mediaWrap = document.querySelector(".inr-media-wrap");
    if (!mediaWrap) return;

    // wrapper rect
    let wrapTop = mediaWrap.getBoundingClientRect().top + 136;

    // viewport center (inner-media fixed center point)
    let viewportCenter = window.innerHeight / 2;
    // When wrapper top reaches inner-media fixed center → remove
    if (wrapTop <= viewportCenter) {
      document.body.classList.remove("add-img-fixed");
    } else {
      document.body.classList.add("add-img-fixed");
    }
  }
}

window.addEventListener("scroll", checkStickyBar);
window.addEventListener("load", checkStickyBar);

let resizeTimeout;
window.addEventListener("resize", function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(checkStickyBar, 150);
});

document.querySelectorAll('.gift-var-close').forEach(closeBtn => {
  closeBtn.addEventListener('click', function () {
    const parentGiftBtns = this.closest('.gift-btns');
    if (parentGiftBtns) {
      parentGiftBtns.classList.remove('active-addcart');
    }
  });
});

// ===========================================================================================================================================


// function updateFixed() {
//   const product_wrap = document.querySelector('.product-wrap');
//   if (!product_wrap) return;
//   function isMobile() {
//     return window.innerWidth <= 991;
//   }
//   function checkSection() {
//     if (!isMobile()) {
//       document.body.classList.add('add-img-fixed');
//       return;
//     }
//     const rect_val = product_wrap.getBoundingClientRect();
//     const sectionIn_view = rect_val.top < window.innerHeight && rect_val.bottom > 0;
//     const sectionEnd_reached = rect_val.bottom <= window.innerHeight;

//     // Calculate how far the user has scrolled into the section
//     const scrolledInto_section = Math.max(0, window.innerHeight - rect_val.top);

//     // if (sectionIn_view && !sectionEnd_reached && scrolledInto_section > 150) {
//     if (scrolledInto_section > window.innerHeight) {  
//       document.body.classList.remove('add-img-fixed');
//     } else {
//       document.body.classList.add('add-img-fixed');
//     }
//   }

//   window.addEventListener('scroll', checkSection, { passive: true });
//   window.addEventListener('resize', checkSection);
//   checkSection();
// }

// document.addEventListener('DOMContentLoaded', updateFixed);


// ================================================================================================================================================

// if (window.innerWidth <= 991) {
//   window.addEventListener('load', function() {
//     document.querySelectorAll('.inr-media-wrap').forEach(function(wrapper) {
//       const inner = wrapper.querySelector('.inner-media');
//       if (inner) {
//         wrapper.style.minHeight = inner.offsetHeight + 'px';
//       }
//     });

//     const body = document.body;
//     const mediaWrap = document.querySelector('.inr-media-wrap');
//     const inner = mediaWrap ? mediaWrap.querySelector('.inner-media') : null;

//     if (!mediaWrap || !inner) return;
//     mediaWrap.style.minHeight = inner.offsetHeight + 'px';
//     body.classList.add('add-img-fixed');
//     let storedInnerTop = inner.getBoundingClientRect().top;
//     setTimeout(() => {
//       storedInnerTop = inner.getBoundingClientRect().top;
//     }, 500);

//     let lastScrollY = window.scrollY;

//     window.addEventListener('scroll', function () {
//       const wrapRect = mediaWrap.getBoundingClientRect();
//       const innerRect = inner.getBoundingClientRect();

//       const scrollingDown = window.scrollY > lastScrollY;
//       const scrollingUp = window.scrollY < lastScrollY;
//       const diff = Math.abs(wrapRect.top - innerRect.top);
//       if (scrollingDown && diff <= 2 && body.classList.contains('add-img-fixed')) {
//         body.classList.remove('add-img-fixed');
//         body.classList.add('img-unfixed');
//       }
//       if (scrollingUp && innerRect.top >= storedInnerTop && body.classList.contains('img-unfixed')) {
//         body.classList.remove('img-unfixed');
//         body.classList.add('add-img-fixed');
//       }

//       lastScrollY = window.scrollY;
//     });

//     window.addEventListener('resize', () => {
//       storedInnerTop = inner.getBoundingClientRect().top;
//     });
      
//   });
// }

// ================================================================================================================================================
// if (window.innerWidth <= 991) {
//   window.addEventListener('load', function() {
//     const body = document.body;
//     const mediaWrap = document.querySelector('.inr-media-wrap');
//     const inner = mediaWrap ? mediaWrap.querySelector('.inner-media') : null;
//     if (!mediaWrap || !inner) return;
//     mediaWrap.style.minHeight = inner.offsetHeight + 'px';
//     body.classList.add('add-img-fixed');
//     let storedInnerTop = inner.getBoundingClientRect().top;
//     setTimeout(() => {
//       storedInnerTop = inner.getBoundingClientRect().top;
//     }, 500);
//     let lastScroll = 0;
//     const threshold = 10;
//     // :point_down: Listen Lenis scroll instead of window scroll
//     // Assume lenis is globally available (window.lenis)
//     if (window.lenis) {
//       window.lenis.on('scroll', ({ scroll }) => {
//         const wrapRect = mediaWrap.getBoundingClientRect();
//         const innerRect = inner.getBoundingClientRect();
//         const scrollingDown = scroll > lastScroll;
//         const scrollingUp = scroll < lastScroll;
//         const diff = Math.abs(wrapRect.top - innerRect.top);
//         if (scrollingDown && diff <= threshold && body.classList.contains('add-img-fixed')) {
//           body.classList.remove('add-img-fixed');
//           body.classList.add('img-unfixed');
//         }
//         if (scrollingUp && innerRect.top >= storedInnerTop - threshold && body.classList.contains('img-unfixed')) {
//           body.classList.remove('img-unfixed');
//           body.classList.add('add-img-fixed');
//         }
//         lastScroll = scroll;
//       });
//     } else {
//       // fallback if Lenis not found
//       let ticking = false;
//       window.addEventListener('scroll', () => {
//         if (!ticking) {
//           window.requestAnimationFrame(() => {
//             const wrapRect = mediaWrap.getBoundingClientRect();
//             const innerRect = inner.getBoundingClientRect();
//             const scrollingDown = window.scrollY > lastScroll;
//             const scrollingUp = window.scrollY < lastScroll;
//             const diff = Math.abs(wrapRect.top - innerRect.top);
//             if (scrollingDown && diff <= threshold && body.classList.contains('add-img-fixed')) {
//               body.classList.remove('add-img-fixed');
//               body.classList.add('img-unfixed');
//             }
//             if (scrollingUp && innerRect.top >= storedInnerTop - threshold && body.classList.contains('img-unfixed')) {
//               body.classList.remove('img-unfixed');
//               body.classList.add('add-img-fixed');
//             }
//             lastScroll = window.scrollY;
//             ticking = false;
//           });
//           ticking = true;
//         }
//       });
//     }
//     window.addEventListener('resize', () => {
//       storedInnerTop = inner.getBoundingClientRect().top;
//     });
//   });
// }
